var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
// js/common/utilities/format-money.js
function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

document.addEventListener("DOMContentLoaded", function(event) {
  const drawerConfigurator = document.querySelector('.configurator');
  if(drawerConfigurator){
    drawerConfigurator.addEventListener("dialog:after-show", function(e) {
      console.log('opened');
      document.body.removeAttribute("hidden");
    });
    drawerConfigurator.addEventListener("dialog:after-hide", function(e) {
      window.history.replaceState(null, '', window.location.pathname);
    });
  }
  
  const drawerSearch = document.querySelector('#search-drawer');
  if(drawerSearch) {
    drawerSearch.addEventListener("dialog:after-show", function(e) {
      const drawerHeaderSidebar = document.querySelector('#header-sidebar-menu');
      drawerHeaderSidebar.hide()
    });
  }
});

var accessoriesCheckboxes = document.querySelectorAll('.config-accessories input[type="checkbox"]');
if (accessoriesCheckboxes) {
  Array.from(accessoriesCheckboxes).forEach(accessoriesCheckbox => {
    accessoriesCheckbox.addEventListener('change', function(event) {
      
      let priceConfigurator = document.querySelector(".price-list-configurator");
      let priceConfiguratorProductCurrent = parseInt(priceConfigurator.dataset.productPriceCurrent);
      let priceConfiguratorAccessoriesCurrent = parseInt(priceConfigurator.dataset.accessoriesTotalCurrent);
  
      var accessoriesTotal = 0;
      var accessoriesCheckedCheckboxes = document.querySelectorAll('.config-accessories input[type="checkbox"]:checked');
      for (var i = 0; i < accessoriesCheckedCheckboxes.length; i++) {
        accessoriesTotal += parseInt(accessoriesCheckedCheckboxes[i].dataset.accessoryPrice);
      }
      let priceConfiguratorNew = priceConfiguratorProductCurrent + accessoriesTotal;
  
      priceConfigurator.setAttribute('data-accessories-price-current', accessoriesTotal);
      priceConfigurator.setAttribute('data-product-price-total', priceConfiguratorNew);
  
      // console.log('Product:', priceConfiguratorProductCurrent);
      // console.log('Accessories:', accessoriesTotal);
      // console.log('Total:', priceConfiguratorNew);
  
      priceConfigurator.querySelector('sale-price').innerText = formatMoney(priceConfiguratorNew, currencyFormat)
  
    });
  });
}
 